module.exports = __webpack_public_path__ + "static/img/UY.e38c739d.png";